// extracted by mini-css-extract-plugin
export default {"Button":"cnnR5krJ"};